import React, { useEffect, useState } from 'react';
import styles from './style.module.css';
import { BackPage, Spinner } from 'components';
import { useHistory } from 'react-router-dom';
import bellImg from 'assets/bell.svg';
import dateFunctions from 'helpers/dateFunction';
import { useScrollBlock, useOrderReminder, useOrderHistory } from 'hooks';
import { useSelector } from 'react-redux';

const OrderReminders = () => {
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);
  const [reminder, setReminder] = useState({});
  const [blockScroll, allowScroll] = useScrollBlock();
  const [deleteOrderReminder] = useOrderReminder();
  const [getOrders] = useOrderHistory();

  const { orders, loading } = useSelector((state) => state.orderHistory);

  const ModalActions = [
    <button
      className={`${styles.button} ${styles.deleteReminderConfirmation}`}
      onClick={handleDeleteReminder}
      onKeyPress={(e) => {
        if (e.key === 'Enter') {
          handleDeleteReminder;
        }
      }}>
      Yes
    </button>,
    <button
      className={styles.button}
      onClick={() => {
        setReminder({});
        setShowModal(false);
      }}
      onKeyPress={(e) => {
        if (e.key === 'Enter') {
          setReminder({});
          setShowModal(false);
        }
      }}>
      No
    </button>,
  ];

  async function handleDeleteReminder() {
    await deleteOrderReminder(reminder.id);
    setReminder({});
    setShowModal(false);
    await getOrders();
  }
  const filterOrders = (orders) => {
    return orders.length > 0
      ? orders
          .filter((o) => o?.reminder?.status === 'created' && o)
          .sort((a, b) => new Date(a.reminder.reminder_date) - new Date(b.reminder.reminder_date))
      : [];
  };

  useEffect(() => {
    showModal ? blockScroll() : allowScroll();
  }, [showModal]);

  return (
    <BackPage onBackClick={() => history.goBack()} bplg="10">
      {showModal && <Modal header="Are you sure you want to remove this reminder?" actions={ModalActions} />}
      <div className="coop-l-container">
        <h1 className={styles.pageHeader}>Order reminders</h1>
        <div className={styles.wrapper}>
          {loading && <Spinner />}
          {!loading && orders && filterOrders(orders).length === 0 && (
            <p className={styles.subHeading}>You don&apos;t have any order reminders set up yet.</p>
          )}
          {!loading &&
            orders &&
            orders.length > 0 &&
            filterOrders(orders).map((order) => {
              return (
                <div key={order.order_id} className={styles.container}>
                  <div className={styles.headerContainer}>
                    <img src={bellImg} alt="bell" />
                    <h2 className={styles.header} data-testid='reminder-date'>{`Reminder on ${dateFunctions.formatDateWithNthNumber(
                      new Date(order.reminder.reminder_date)
                    )}`}</h2>
                    <button
                      className={styles.deleteReminderButton}
                      onClick={() => {
                        setReminder(order.reminder);
                        setShowModal(true);
                      }}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          setReminder(order.reminder);
                          setShowModal(true);
                        }
                      }}>
                      &#10005;
                    </button>
                  </div>
                  <ul>
                    {order.order_items.map((item) => {
                      return <li key={item.name}>{item.name}</li>;
                    })}
                  </ul>
                </div>
              );
            })}
        </div>
      </div>
    </BackPage>
  );
};

const Modal = ({ header, actions }) => {
  return (
    <div className={styles.overlay}>
      <div className={styles.modalContainer}>
        <div className={styles.modalHeaderContainer}>
          <h2 className={styles.header}>{header}</h2>
        </div>
        <div className={styles.modalActionContainer}>{actions.map((a,i) => <React.Fragment key={`${a}${i}`}>{a}</React.Fragment>)}</div>
      </div>
    </div>
  );
};

export default OrderReminders;
